import fetchAPI, { IHttpError } from '../../../lib/utils/fetch-api'
import {
  setHrCancelFormData,
  setHrEnumsData,
  setHrEnumsFailed,
  setHrEnumsLoading,
  setHrFormCandidateId,
  setHrFormData,
  setHrFormFailed,
  setHrFormLoading,
  setHrFormSuccessUpdate,
} from './actions'
import { handleStageConflictResponse } from '../../lib/stage-conflict'
import { setCalendarHrTypes, setCalendarHrTypesFailed } from '../calendar/actions'

function formatHrApiErrors(error: unknown): string {
  if (Array.isArray(error)) {
    return error
      .map(item => {
        if (typeof item === 'string') return item
        if (item && typeof item === 'object') {
          const detail = (item as { detail?: string; message?: string }).detail
          const message = (item as { detail?: string; message?: string }).message
          return detail || message || ''
        }
        return String(item)
      })
      .filter(Boolean)
      .join(', ')
  }
  if (error && typeof error === 'object') {
    const detail = (error as { detail?: string; message?: string }).detail
    const message = (error as { detail?: string; message?: string }).message
    if (detail || message) return detail || message || ''
  }
  return String(error ?? '')
}

function hrLoadErrorFromCatch(err: unknown) {
  const statusCode = Number((err as IHttpError)?.statusCode) || 'error'
  const message =
    (err as IHttpError)?.message ||
    (statusCode === 404 ? 'Заявка не найдена' : 'При загрузке карточки возникла ошибка')
  return {
    message,
    statusCode: statusCode === 404 ? 404 : statusCode,
  }
}

export function getHrForm(id) {
  return async dispatch => {
    dispatch(setHrFormLoading())
    try {
      if (id !== 'new' && !/^\d+$/.test(String(id || ''))) {
        return dispatch(
          setHrFormFailed({ message: 'Заявка не найдена', statusCode: 404 }),
        )
      }

      const response = (await fetchAPI(`/api/hr/request/${id}`)) || []

      if (response['errors'] || response?.error) {
        return dispatch(
          setHrFormFailed({
            message:
              formatHrApiErrors(response['errors'] || response?.error) || 'Заявка не найдена',
            statusCode: 404,
          }),
        )
      }

      if (response['cancelModal']) {
        dispatch(setHrCancelFormData(response['cancelModal']))
      }
      return dispatch(setHrFormData(response))
    } catch (err) {
      return dispatch(setHrFormFailed(hrLoadErrorFromCatch(err)))
    }
  }
}

export function nextStage(id, formData) {
  return async dispatch => {
    dispatch(setHrFormLoading())
    try {
      const response = await fetchAPI(`/api/hr/request/${id}`, {
        method: 'POST',
        body: JSON.stringify(formData),
      })

      if (handleStageConflictResponse(response, () => dispatch(getHrForm(id)))) {
        return
      }

      if (response['errors']) {
        return dispatch(setHrFormFailed(formatHrApiErrors(response['errors'])))
      }
      return dispatch(setHrFormData(response))
    } catch (err) {
      return dispatch(setHrFormFailed(err as string))
    }
  }
}

export function updateFormData(id, formData) {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/hr/request/${id}`, {
        method: 'POST',
        body: JSON.stringify(formData),
      })

      if (response['errors']) {
        return dispatch(setHrFormFailed(formatHrApiErrors(response['errors'])))
      }

      if ((!id || id === 'new') && response?.id) {
        return dispatch(setHrFormCandidateId(response.id))
      }
      return dispatch(setHrFormSuccessUpdate())
    } catch (err) {
      return dispatch(setHrFormFailed(err as string))
    }
  }
}

export function getHrEnums() {
  return async dispatch => {
    dispatch(setHrEnumsLoading())
    try {
      const response = await fetchAPI('/api/hr/request/enum')

      if (response['errors']) {
        return dispatch(setHrEnumsFailed(formatHrApiErrors(response['errors'])))
      }
      return dispatch(setHrEnumsData(response))
    } catch (err) {
      return dispatch(setHrEnumsFailed(err as string))
    }
  }
}

export function getTaskTypeHrTasksList() {
  return async dispatch => {
    try {
      const response = await fetchAPI(`/api/v2/task/hr/enum`)
      if (response['errors']) {
        return dispatch(setCalendarHrTypesFailed(formatHrApiErrors(response['errors'])))
      }
      return dispatch(setCalendarHrTypes(response || []))
    } catch (err) {
      return dispatch(setCalendarHrTypesFailed('ошибка загрузки типов задач: ' + err))
    }
  }
}
